import { OptimizationRecommendationsType } from '@vi-iot/client';

export const optimizationRecommendationsKey = 'optimizationRecommendations';

export interface IgnoredOptimizationRecommendationTileSettings {
  [key: number]: OptimizationRecommendationSlug[];
}

export enum OptimizationRecommendationSlug {
  hc0 = 'hc0',
  hc1 = 'hc1',
  hc2 = 'hc2',
  hc3 = 'hc3',
  hc4 = 'hc4',
  hc5 = 'hc5',
  hc6 = 'hc6',
  dhw = 'dhw',
}

export interface OptimizationRecommendationSpreaded {
  type: OptimizationRecommendationsType;
  translationSlug: string;
  hc?: string;
}

export interface InstallationWithRecommendation {
  id: number;
  gatewaySerial: string;
  location: string;
  ownerName: string;
  marketingName?: string;
  image: string;
  recommendations: OptimizationRecommendationSpreaded[];
}
